export const AUTH_TOKEN = 'auth-token'
export const API_URL = 'https://api-salvus-client.sandbox.sceme.io'
export const PLATFORM = 'staging'
export const RECAPTCHA_KEY = '84047ffc-d8fc-4de2-b046-2840ff2a58d4'

export const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
